/**
 * @generated SignedSource<<1c6b51d35dc0d28049b0c0ad150745e0>>
 * @relayHash e8f967b0a65a9059a78a5c5e9e397c62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b59e09108aa5d51e4f9218646b5c7b34e86fb9a77109747e0f966f26d798b092

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioHandoffConfigAppQuery$variables = {
  helpCenterAri: string;
};
export type AgentStudioHandoffConfigAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly " $fragmentSpreads": FragmentRefs<"configuration_AtlassianCsmHandoffConfig_queryReference">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AgentStudioHandoffConfigAppQuery = {
  response: AgentStudioHandoffConfigAppQuery$data;
  variables: AgentStudioHandoffConfigAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentStudioHandoffConfigAppQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "kind": "LinkedField",
          "name": "csmAi_getAiHubByHelpCenterAri",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "configuration_AtlassianCsmHandoffConfig_queryReference"
                }
              ],
              "type": "CsmAiHub"
            }
          ]
        },
        "action": "THROW",
        "path": "csmAi_getAiHubByHelpCenterAri"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentStudioHandoffConfigAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "handoffConfigs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "enabled"
                      },
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "connectorConfiguration",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ],
                            "type": "CsmAiMessageHandoff"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "formId"
                              }
                            ],
                            "type": "CsmAiTicketingHandoff"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiHandoffConfig"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b59e09108aa5d51e4f9218646b5c7b34e86fb9a77109747e0f966f26d798b092",
    "metadata": {},
    "name": "AgentStudioHandoffConfigAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a7f5e5cd0d9145da4fc9a12ac2dee70f";

export default node;
